import React, { useState } from 'react';
import Modal from 'react-modal';
Modal.setAppElement('#root'); // Para accesibilidad del modal

const CrearConsentimientoModal = ({ isOpen, onClose, servicios, onSave }) => {
    const [nombreConsentimiento, setNombreConsentimiento] = useState('');
    const [servicioLigado, setServicioLigado] = useState('');
    const [consentimiento, setConsentimiento] = useState('');

    const handleSave = () => {
        const newConsentimiento = {
            nombreConsentimiento,
            servicioLigado,
            consentimiento,
        };
        onSave(newConsentimiento);
        setNombreConsentimiento('');
        setServicioLigado('');
        setConsentimiento('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="w-[60%] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
            overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[10]"
        >
            <h2 className="text-2xl text-left text-[#205087ff] font-bold mb-4">Crear consentimiento</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 text-left gap-4">
                <div className="form-group">
                    <label className="form-label">Nombre del Consentimiento:</label>
                    <input
                        type="text"
                        required
                        value={nombreConsentimiento}
                        onChange={(e) => setNombreConsentimiento(e.target.value)}
                        className="form-input"
                    />
                </div>
                <div className="form-group">
                    <label className="form-label">Servicio Ligado:</label>
                    <select
                        value={servicioLigado}
                        required
                        onChange={(e) => setServicioLigado(e.target.value)}
                        className="form-input"
                    >
                        <option value="" required>Selecciona una opcion</option>
                        {servicios.map((servicio) => (
                            <option key={servicio._id} value={servicio.service}>
                                {servicio.service}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group">
                    <label className="form-label">Consentimiento:</label>
                    <textarea
                        required
                        value={consentimiento}
                        onChange={(e) => setConsentimiento(e.target.value)}
                        className="form-input"
                    />
                </div>
            </div>
            <div className="flex justify-end gap-3">
                <button
                    onClick={handleSave}
                    className="button-send"
                >
                    Guardar
                </button>
                <button
                    onClick={onClose}
                    className="button-gray"
                >
                    Cancelar
                </button>
            </div>
        </Modal>
    );
};

export default CrearConsentimientoModal;
